import { useState } from "react";
import { ImagePlus, Loader2, X, Play } from "lucide-react";
import { toast } from "sonner";
import { api, API, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export const mediaUrl = (id) => `${API}/media/${id}`;

export const MediaUploader = ({ token, items, onChange, testid }) => {
  const [busy, setBusy] = useState(0);
  const upload = async (files) => {
    for (const file of Array.from(files || [])) {
      setBusy(1);
      const fd = new FormData();
      fd.append("file", file);
      try {
        const { data } = await api.post(`/public/invite/${token}/media`, fd, {
          onUploadProgress: (e) => setBusy(Math.max(1, Math.round((e.loaded / (e.total || 1)) * 100))),
        });
        onChange((prev) => [...prev, { ...data, preview: URL.createObjectURL(file) }]);
      } catch (e) {
        toast.error(`${file.name}: ${errMsg(e)}`);
      }
    }
    setBusy(0);
  };
  return (
    <div className="flex flex-wrap gap-2 items-center" data-testid={testid}>
      {items.map((m) => (
        <div key={m.id} className="relative h-20 w-20 rounded-md overflow-hidden border border-gray-200 bg-gray-900">
          {m.kind === "video" ? <video src={m.preview} muted className="h-full w-full object-cover" /> : <img src={m.preview} alt="" className="h-full w-full object-cover" />}
          {m.kind === "video" && <Play size={18} className="absolute inset-0 m-auto text-white" />}
          <button type="button" onClick={() => onChange((prev) => prev.filter((x) => x.id !== m.id))} className="absolute top-1 right-1 h-5 w-5 rounded-full bg-white/90 flex items-center justify-center" aria-label="Rimuovi" data-testid={`${testid}-remove-${m.id}`}><X size={12} /></button>
        </div>
      ))}
      <label className="h-20 w-20 rounded-md border-2 border-dashed border-gray-300 hover:border-emerald-600 transition-colors flex flex-col items-center justify-center text-xs text-gray-500 cursor-pointer">
        <input type="file" multiple accept="image/jpeg,image/png,image/webp,video/mp4,video/quicktime,video/webm" className="hidden" disabled={!!busy}
          onChange={(e) => { upload(e.target.files); e.target.value = ""; }} data-testid={`${testid}-input`} />
        {busy ? <><Loader2 size={18} className="animate-spin" /><span>{busy}%</span></> : <><ImagePlus size={18} /><span>Foto/video</span></>}
      </label>
    </div>
  );
};

export const MediaGallery = ({ media, onDelete, size = "h-20 w-20" }) => {
  const [open, setOpen] = useState(null);
  if (!media?.length) return null;
  return (
    <>
      <div className="mt-4 flex flex-wrap gap-2" data-testid="review-media-gallery">
        {media.map((m) => (
          <div key={m.id} className={`relative ${size} rounded-md overflow-hidden border border-gray-200 bg-gray-900`}>
            <button type="button" className="h-full w-full" onClick={() => setOpen(m)} data-testid={`media-open-${m.id}`} aria-label={m.kind === "video" ? "Guarda il video" : "Apri la foto"}>
              {m.kind === "video"
                ? <><video src={`${mediaUrl(m.id)}#t=0.5`} preload="metadata" muted className="h-full w-full object-cover" /><Play size={20} className="absolute inset-0 m-auto text-white drop-shadow" /></>
                : <img src={mediaUrl(m.id)} alt="Foto del cliente" loading="lazy" className="h-full w-full object-cover hover:scale-105 transition-transform duration-200" />}
            </button>
            {onDelete && <button type="button" onClick={() => onDelete(m)} className="absolute top-1 right-1 h-5 w-5 rounded-full bg-white/90 flex items-center justify-center" aria-label="Elimina file" data-testid={`media-delete-${m.id}`}><X size={12} /></button>}
          </div>
        ))}
      </div>
      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="max-w-3xl p-2 bg-black border-0" data-testid="media-lightbox">
          <DialogTitle className="sr-only">Media recensione</DialogTitle>
          {open && (open.kind === "video"
            ? <video src={mediaUrl(open.id)} controls autoPlay playsInline className="w-full max-h-[80vh]" />
            : <img src={mediaUrl(open.id)} alt="Foto del cliente" className="w-full max-h-[80vh] object-contain" />)}
        </DialogContent>
      </Dialog>
    </>
  );
};
